module.exports = __webpack_public_path__ + "static/media/whiteriver.35f53f71.png";